/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useParams } from "react-router-dom";
import { Box, theme } from "@nordcloud/gnui";
import { BrickLoader, TableLoader, UniversalWrap } from "~/components";
import { isNotNil } from "~/tools";
import { BusinessContextKpiWidget } from "./BusinessContextKpiWidget";
import { useBusinessContext } from "./hooks";
import { OrganizationUnitsList } from "./OrganizationUnit/Lists";
import { OrganizationUnitsHeader } from "./OrganizationUnitsHeader";

type RouteParams = {
  structureId: string;
};

export function OrganizationUnits() {
  const { structureId = "" } = useParams<RouteParams>();

  const { data, loading, error, refetch, units } =
    useBusinessContext(structureId);

  return (
    <UniversalWrap
      errorProps={{ error }}
      loaderProps={{ loading, Component: Loader }}
    >
      {isNotNil(data) && isNotNil(data.businessContext) && (
        <OrganizationUnitsHeader
          businessContext={data.businessContext}
          onChange={refetch}
        />
      )}
      <BusinessContextKpiWidget businessContext={structureId} />
      <Box>
        <OrganizationUnitsList
          orgUnits={units}
          businessContextId={structureId}
          onAction={refetch}
        />
      </Box>
    </UniversalWrap>
  );
}

function Loader() {
  return (
    <>
      <BrickLoader
        viewBox="0 0 16 1"
        style={{
          display: "block",
          height: "auto",
          marginBottom: theme.spacing.spacing04,
        }}
      />
      <BrickLoader
        viewBox="0 0 8 1"
        style={{
          display: "block",
          height: "auto",
          marginBottom: theme.spacing.spacing04,
        }}
      />
      <TableLoader
        gapY={10}
        gapX={6}
        rows={[
          {
            height: 100,
            count: 1,
            items: [
              {
                widthPercent: 100,
              },
            ],
          },
          {
            height: 60,
            count: 7,
            items: [
              {
                widthPercent: 52,
              },
              {
                widthPercent: 5,
              },
              {
                widthPercent: 12,
              },
              {
                widthPercent: 12,
              },
              {
                widthPercent: 19,
              },
            ],
          },
        ]}
      />
    </>
  );
}
